import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { GasDatepickerDirective } from './gas-datepicker.directive';

const DIRECTIVES = [
  GasDatepickerDirective,
];

@NgModule({
  declarations: [
    DIRECTIVES,
  ],
  exports: [
    DIRECTIVES,
  ],
  imports: [
    CommonModule,
  ],
})
/** @deprecated */
export class GasDatepickerDirectiveModule { }
